import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as personas from '../../personas'

export const RESOURCE = {
  payload: {
    description:
      'An archetype representing a group of stakeholders who share similar roles, needs, and experiences of a change.',
    dimension: personas.RESOURCE.payload,
    level: 0,
    name: 'Persona',
    partialId: PartialId.Standard.create('persona'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
